import type {
  ChannelAgentBinding,
  TriggerMatch,
} from '../core/contracts/channel-agent.js';

export interface ChannelMessageContext {
  messageText: string;
  senderId: string;
  isReplyToAgent?: boolean;
}

export class TriggerMatcher {
  evaluateMessageTrigger(
    binding: ChannelAgentBinding,
    context: ChannelMessageContext
  ): TriggerMatch {
    // 1. Paused or revoked bindings NEVER respond
    if (binding.status !== 'active') {
      return { matched: false, reason: 'none' };
    }

    const text = context.messageText.trim();
    const lower = text.toLowerCase();

    // Precedence 1: Explicit Slash/Command
    for (const cmd of binding.triggerPolicy.respondToCommands) {
      if (lower.startsWith(cmd.toLowerCase())) {
        return {
          matched: true,
          reason: 'command',
          confidence: 1.0,
          matchedToken: cmd,
        };
      }
    }

    // Precedence 2: Direct Mention
    if (binding.triggerPolicy.respondWhenMentioned) {
      const mentionTokens = [`@${binding.agentId.toLowerCase()}`, `@scrum`, `@${binding.role.toLowerCase()}`];
      for (const token of mentionTokens) {
        if (lower.includes(token)) {
          return {
            matched: true,
            reason: 'mention',
            confidence: 0.95,
            matchedToken: token,
          };
        }
      }
    }

    // Precedence 3: Reply to Agent Message
    if (context.isReplyToAgent) {
      return {
        matched: true,
        reason: 'reply',
        confidence: 0.85,
      };
    }

    // Precedence 4: Configured Keyword
    for (const kw of binding.triggerPolicy.respondToKeywords) {
      if (lower.includes(kw.toLowerCase())) {
        return {
          matched: true,
          reason: 'keyword',
          confidence: 0.7,
          matchedToken: kw,
        };
      }
    }

    return { matched: false, reason: 'none' };
  }
}
